import type { ReactNode } from "react";

type PrimaryCardButtonProps = {
  title: string;
  onClick: () => void;
  icon?: ReactNode;
};

export function PrimaryCardButton({ title, onClick, icon }: PrimaryCardButtonProps) {
  return (
    <button
      type="button"
      onClick={() => {
        onClick();
      }}
      className="white-button"
      style={{
        position: "relative",
        zIndex: 20,
        alignItems: "center",
        padding: "16px 24px",
        boxShadow: "0px 7px 7.68px rgba(0, 0, 0, 0.21)",
        borderRadius: 8,
        backgroundColor: "white",
        display: "inline-flex",
        justifyContent: "center",
        gap: 8,
        width: 180,
        cursor: "pointer",
        border: "none",
      }}
    >
      {icon ? <span style={{ display: "inline-flex" }}>{icon}</span> : null}
      <span style={{ fontWeight: "bold", fontSize: 18, color: "var(--bs-primary)" }}>{title}</span>
    </button>
  );
}